module.exports = __webpack_public_path__ + "img/18.9382e61f.png";